import { colors, FelaCSS, FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  container: FelaCSS;
  toolbar: FelaCSSWithCustomSelectors;
  optionsBox: FelaCSS;
  optionBtn: FelaCSSWithCustomSelectors;
  galleryContainer: FelaCSS;
  galleryBox: FelaCSSWithCustomSelectors;
  contactBox: FelaCSS;
  contactIcon: FelaCSS;
  contactClose: FelaCSS;
  contactTitle: FelaCSS;
  contactDescription: FelaCSS;
  contactMobile: FelaCSS;
}

const styles = (): IStyles => ({
  container: {
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: colors.space04,
  },
  toolbar: {
    height: 58,
    background: colors.white,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingLeft: spacing[2],

    '& button:first-child': {
      marginRight: 'auto',
    },
  },
  optionsBox: {
    gap: spacing[2],
    flexDirection: 'row',
    marginRight: 'auto',
  },
  optionBtn: {
    whiteSpace: 'nowrap',
    paddingHorizontal: spacing[8],

    '& svg': {
      color: colors.blushTangerine120,
    },

    maxWidthTabletSm: {
      paddingHorizontal: spacing[2],
    },
  },
  galleryContainer: {
    overflow: 'scroll',
  },
  galleryBox: {
    position: 'relative',
    margin: `${spacing[8]} auto ${spacing[3]}`,
    background: colors.space04,
    display: 'grid',
    marginBottom: 3,
    gap: spacing[3],
    width: 788,

    maxWidthTabletSm: {
      width: '100%',
      gap: 8,
      margin: `${spacing[0]} ${spacing[0]} ${spacing[2]}`,
    },

    '& > div': {
      borderRadius: spacing[2],
      overflow: 'hidden',
      cursor: 'initial',

      maxWidthTabletSm: {
        borderRadius: 0,
      },
    },
  },
  contactBox: {
    position: 'fixed',
    borderRadius: spacing[1],
    background: colors.white,
    bottom: 10,
    right: 94,
    padding: 4,
    color: colors.space,
    textAlign: 'center',
  },
  contactIcon: {
    fontSize: 36,
    margin: `${spacing[8]} ${spacing[0]}`,
  },
  contactClose: {
    position: 'absolute',
    top: spacing[2],
    right: spacing[4],
    height: spacing[6],
    width: spacing[6],
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  contactTitle: {
    fontPlayfair: 28,
    fontWeight: 800,
  },
  contactDescription: {
    fontDefault: 16,
    lineHeight: '150%',
    margin: `${spacing[4]} ${spacing[0]} ${spacing[6]}`,
  },
  contactMobile: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
  },
});

export default styles;
